export async function updateTransaction(transactionData: {
  id: string;
  name: string;
  amount: string;
  date: string;
  category?: string;
  externalId?: string;
  source?: string;
  propertyId?: string | null; // Optional, can be null if not provided
  organizationId: string; // Required organization ID
}) {
  try {
    const response = await fetch(`/api/transactions/${transactionData.id}`, {
      method: "PUT", // or 'PATCH' if you want a partial update
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(transactionData),
    });
    if (!response.ok) {
      throw new Error("Error updating transaction");
    }
    const data = await response.json();

    return data.transaction;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
